import proximaImg from "../assets/proximaGif.gif";
import mkImg from "../assets/mkBooks.gif";
import vtsImg from "../assets/vtsBoard.png";



const projects = [
  // {
  //   title: "Urban Infrastructure Information - AR",
  //   technologies: "AR Foundation, Unity, C#, Swift, AR Kit, GDelt API, OpenStreetMap API",
  //   description: [
  //     "Augmented Reality application that renders imagery and content using geolocation. To be used with wrapper applications",
  //     "Inspired by the cutting-edge capabilities of GDELT's global news imagery analysis through Google Cloud Vision API, I am in the process of developing an iOS augmented reality application to harness these technologies for real-time news visualization. By integrating AI-driven annotations like content-based geolocation and OCR, this app aims to offer users an immersive and informative view of world events, setting the stage for future expansion to wearable technologies. \nBuilt using Swift, AR Foundation, Unity, AR Kit, GDelt API, and the OpenStreetMap API",
  //   ],
  //   imageLink: null,
  //   role: "Fullstack engineer, and UX designer",
  //   links: [],
  //   linkTitle: 'Learn More',
  //   pageLink: "",
  //   year: '2025 - Present',
  //   projectImg: null,
  //   slug: 'visual-global-knowledge-graph'
  // },
  // {
  //   title: "Gaussian Splatting Scale for Spatial Journalism",
  //   technologies: "PostShot, PyTorch, Three.js/R3F, SuperSplat/Blender, Scaniverse, Improvised camera rig",
  //   description: [
  //     "Explores improving absolute scale and geometric accuracy for capture workflows",
  //     "Inspired by the cutting-edge capabilities of GDELT's global news imagery analysis through Google Cloud Vision API, I am in the process of developing an iOS augmented reality application to harness these technologies for real-time news visualization. By integrating AI-driven annotations like content-based geolocation and OCR, this app aims to offer users an immersive and informative view of world events, setting the stage for future expansion to wearable technologies. \nBuilt using Swift, AR Foundation, Unity, AR Kit, GDelt API, and the OpenStreetMap API",
  //   ],
  //   imageLink: null,
  //   role: "Fullstack engineer, and UX designer",
  //   links: [],
  //   linkTitle: 'Read',
  //   pageLink: "",
  //   year: '2025 - Present',
  //   projectImg: null,
  //   slug: 'visual-global-knowledge-graph'
  // },
  {
    title: "Sandbox",
    technologies: "Meta Quest, Superplat, Drone, Handheld cameras, LiDAR, Metashape, Unity, Three.js, Tensorflow, and more.",
    description: [
      "Experiments with augmented & mixed reality, gaussian splatting & 3D models, machine learning, and more",
      "Page to be updated soon."
      // "I am interested in creating photogrammetry models for various use cases but particularly in aiding storytelling. I have made object and space captures using both handheld cameras and drones and have processed them using Metashape and Apple's Object Capture API. I am currently experimenting with Neural Radiance fields (NeRF) to create models.",
    ],
    imageLink: null,
    role: "Developer",
    links: [""],
    linkTitle: 'Learn More',
    pageLink: "",
    year: '2024 - Present',
    projectImg: null,
    slug: 'sandbox'
  },
  // {
  //   title: "Listen",
  //   technologies: "React Native, Django, Postgres, Docker, Redis, Google Maps API",
  //   description: [
  //     "Mobile audio application for indoor and outdoor art exhibits",
  //     "Listen is a mobile audio application for indoor and outdoor art exhibits. Inspired by my time working within arts organizations, I wanted to leverage technology to add an additional layer to viewer experiences, which are often limited to the artwork itself and a caption underneath. Users can access additional information about artworks, projects, artists, take guided tours, and learn about additional exhibit information such as events. Built using React Native, Django, Postgres, Docker, Redis, and Google Cloud",
  //   ],
  //   imageLink: null,
  //   role: "Fullstack engineer, and UX designer",
  //   links: [],
  //   linkTitle: 'Learn More',
  //   pageLink: "",
  //   year: '2024 - 2025',
  //   projectImg: null,
  //   slug: 'listen'
  // },
  {
    title: "Queensbound",
    technologies: "React Native, Django, Postgres, Docker, Redis, Google Maps API",
    description: [
      "Mobile audio tour application using poetry to highlight the borough of Queens",
      "Queensbound is a collaborative audio project founded in 2018 that seeks to connect writers across the New York City borough of Queens, showcase and develop a literature of Queens, and reflect the borough back to itself. This is poetry for the people online and in public spaces.",
    ],
    imageLink: null,
    role: "Product Engineer and UX designer",
    links: [],
    linkTitle: 'App Store',
    pageLink: "",
    year: '2025 - Present',
    projectImg: null,
    slug: 'queensbound'
  },
  {
    title: "BDC - Focus",
    technologies: "React, Three.js, Express, Node.js, Postgres",
    description: [
      "Community newspaper for the Bronx Documentary Center's high school documentary storytelling program.",
      "Community newspaper for the Bronx Documentary Center's high school documentary storytelling program.",
    ],
    imageLink: "/static/media/focus_1.png",
    role: "Product Engineer and UX Designer",
    links: [
      "https://focus.bronxdoc.org/",
    ],
    linkTitle: 'Live Site',
    pageLink: "",
    year: '2025- Present',
    projectImg: '../assets/focus_1.png',
    projectImgAlt: "Proxima application screenshot",
    slug: 'bdc-focus'
  },

  // {
  //   title: "VTS Board",
  //   technologies: "React, Express, Node.js, Firebase, Websockets, Excalidraw API",
  //   description: [
  //     "Educational tool for photo and art teachers",
  //     "Educational tool for photo and art teachers, primarily focusing on using visual thinking strategies (VTS) exercises. Built using React, Tailwind, Websockets, Excalidraw API, Node.js, Express, and Postgres.",
  //   ],
  //   imageLink: "/static/media/vtsBoard.695f0453706e9edf6441.png",
  //   role: "Fullstack engineer, UX Designer",
  //   links: ["https://github.com/santiagojon/vts_board"],
  //   linkTitle: 'Github',
  //   pageLink: "",
  //   year: 2022,
  //   projectImg: vtsImg,
  //   projectImgAlt: "VTS Board application screenshot",
  //   slug: 'vts-board'
  // },
  // {
  //   title: "Latin American Foto Festival Archive",
  //   technologies: "React, Next.js, Django, CMS",
  //   description: [
  //     "Commissioned project for community based nonprofit",
  //     "Educational tool for photo and art teachers, primarily focusing on using visual thinking strategies (VTS) exercises. Built using React, Tailwind, Websockets, Excalidraw API, Node.js, Express, and Postgres.",
  //   ],
  //   imageLink: "/static/media/vtsBoard.695f0453706e9edf6441.png",
  //   role: "Fullstack engineer, UX Designer",
  //   links: ["https://github.com/santiagojon/vts_board"],
  //   linkTitle: 'Live Site',
  //   pageLink: "",
  //   year: 2025,
  //   projectImg: vtsImg,
  //   projectImgAlt: "VTS Board application screenshot",
  //   slug: 'vts-board'
  // },
  {
    title: "Proxima",
    technologies: "React, Three.js, Express, Node.js, Postgres",
    description: [
      "3D educational application that allows users to explore exoplanets and their star systems",
      "3D educational application that dynamically renders the over 5000 known exoplanets from NASA's Exoplanet TAP. Built using React, Redux, Three.js, React Three Fiber, Node.js, Express, Postgres, and React Spring.",
    ],
    imageLink: "/static/media/proximaGif.217ebe735fbb77ecbb77.gif",
    role: "Developer and UX Designer",
    links: [
      // "https://proxima-worlds.herokuapp.com/",
    ],
    linkTitle: 'Live Site - Offline',
    pageLink: "",
    year: 2022,
    projectImg: proximaImg,
    projectImgAlt: "Proxima application screenshot",
    slug: 'proxima'
  },
];

export default projects;

